<template>
    <div class="avue-footer-wapper">
        <div class="footer-text">
            <div class="mb5">
                <span class="mr5 ml5 aaaa"><a href="https://beian.miit.gov.cn" target="_blank"><img src="/img/bg/footer-icon2.png" class="small-logo">闽ICP备15007253号</a></span>
                <span class="mr5 ml5 aaaa"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010302000233" target="_blank"><img src="/img/bg/footer-icon1.png" class="small-logo">闽公安网备35010302000234号</a></span>

                <span class="mr5 ml5 aaaa"><a href="https://myssl.com/seal/detail?domain=xm.vstime.com" target="_blank"><img src="/svg/seal.svg" class="small-logo1" title="安全认证"></a></span>
                <!-- <span class="mr5 ml5 aaaa"><a href="https://v.itrust.cn/?safetykeyid=02c3ec78877919a8303fd2102c5bb283" target="_blank"><img src="/img/bg/cert.png" class="small-logo2" title="iTrust"></a></span> -->
            </div>

            <div>
                <span class="mr5 ml5 aaaa"> Copyright © 公益项目信息化管理解决方案提供商</span>
                <span class="mr5 ml5   aaaa">版本：V1.0 技术支持 <a href="http://www.vstimevms.com" target="_blank">微时刻</a></span></div>
        </div>
    </div>
</template>
<script>
export default {
    name:'footer'
}
</script>
<style lang="scss">
@import "@/styles/footer.scss";
.small-logo1 {
        display: inline-block;
        width: 50px;
        height: 26px;
        margin-right: 5px;
        vertical-align: middle;
    }
    .small-logo2 {
        display: inline-block;
        width: 57px;
        height: 20px;
        margin-right: 5px;
        vertical-align: middle;
    }
</style>
